import type { Label, Participant } from '@/scopes/account/group-responsible/domain/types'
import type {
  GroupBookingAPIResponse,
  ParticipantPaymentInfoAPIResponse,
} from '@/scopes/account/group-responsible/infrastructure/types'
import { getParticipantName } from './utils'

// TODO: refactor, this is UI component logic, not mapper logic
function getParticipantStatus(paymentInfo: ParticipantPaymentInfoAPIResponse): Label {
  if (paymentInfo.totalPaid === 0) {
    return {
      text: 'groups_responsible_not_paid',
      type: 'error',
    }
  }
  if (paymentInfo.totalPaid === paymentInfo.totalToBePaid) {
    return {
      text: 'groups_responsible_paid',
      type: 'success',
    }
  }
  return {
    text: 'groups_responsible_partial_paid',
    type: 'warning',
  }
}

function getAmountDue(paymentInfo: ParticipantPaymentInfoAPIResponse): number {
  return paymentInfo.totalToBePaid - paymentInfo.totalPaid
}

type Service = GroupBookingAPIResponse['data']['childBookings'][number]['services'][number]

function hasService(services: Service[], typeOfService: string, participantId: number): boolean {
  return services.some(service =>
    service.typeOfService === typeOfService
    && service.participantIds.includes(participantId),
  )
}

function getServiceForParticipant(services: Service[], typeOfService: string, participantId: number): Service | undefined {
  return services.find(service =>
    service.typeOfService === typeOfService
    && service.participantIds.includes(participantId),
  )
}

export function mapParticipants(
  childBookings: GroupBookingAPIResponse['data']['childBookings'],
): Record<string, Participant> {
  return childBookings
    .flatMap((item) => {
      return item.participants.map((participant) => {
        const skiPassService = getServiceForParticipant(item.services, 'SkiPass', participant.participantId)
        const skiPassName = skiPassService?.typeDescription || ''
        const hasSkiMaterial = hasService(item.services, 'SkiMaterial', participant.participantId)
        const hasTotallySweater = hasService(item.services, 'Sweater', participant.participantId)

        return {
          id: participant.participantId.toString(),
          bookingNumber: item.bookingNumber,
          name: getParticipantName(participant.firstName, participant.lastName),
          email: participant.email,
          status: getParticipantStatus(participant.paymentInfo),
          room: participant.used ? 'groups_responsible_room_assigned' : 'groups_responsible_room_not_assigned',
          assigned: participant.used,
          amountDue: getAmountDue(participant.paymentInfo),
          telephoneNumber: participant.telephoneNumber,
          mobileNumber: participant.mobileNumber,
          skiPass: skiPassName,
          hasSkiMaterial,
          hasTotallySweater,
          isBusAssignmentProcessing: participant.isBusAssignmentProcessing || false,
          transportType: participant.transportType || 'unknown',
        }
      })
    })
    .reduce((acc: Record<string, Participant>, participant) => {
      acc[participant.id] = participant
      return acc
    }, {})
}
